export const formatKNumber = (value: number) => {
  if (value >= 1000000) {
    return parseFloat((value / 1000000).toFixed(2)) + "M";
  }
  if (value >= 1000) {
    return parseFloat((value / 1000).toFixed(2)) + "K";
  }
  return parseFloat(value.toFixed(3)).toString();
};